import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import ProbeLogo from 'app/components/shared/probeLogo';
import { Chevron } from '@bibliocommons/deprecated-base-icons';

import '../styles/SearchProbe.scss';

class SearchProbe extends React.PureComponent {
  render() {
    const { searchUrl, libraryName, count, siteId } = this.props;

    const searchUrlWithOrigin = searchUrl.concat('&origin=core-holdings-explore');

    if (count > 0) {
      return (
        <div className="cp-search-probe">
          <div className="cp-avatar">
            <ProbeLogo className="library-logo" siteId={siteId} small circled />
          </div>

          <div>
            <div className="library-name">{libraryName}</div>
            <a href={searchUrlWithOrigin} rel="noopener noreferrer" className="search-probe-link">
              <FormattedMessage id="view_results_with_count" values={{ count }} />
              <Chevron.Right />
            </a>
          </div>
        </div>
      );
    }

    return null;
  }
}

SearchProbe.propTypes = {
  siteId: PropTypes.string.isRequired,
  libraryName: PropTypes.string.isRequired,
  count: PropTypes.number,
  searchUrl: PropTypes.string.isRequired
};

export default SearchProbe;
